import React, { useRef, useEffect } from 'react'

function Anchor({ data, refs }) {
  refs[data.anchor] = useRef()

  useEffect(() => {
    const selected = location.hash.replace('#', '').split('?')[0]
    if (selected && selected.length > 0) {
      refs[selected] && refs[selected]?.current?.scrollIntoView()
    }
  }, [])

  return <a ref={refs[data.anchor]} id={data.anchor} />
}

export default Anchor
